import * as rutHelpers from 'rut-helpers';

// Who the Sales orders go to on the incorporation screen's first step: a
// patient Kuido has, or a new one with its RUT and main address (located on the
// map, so the app's visits can use it). Kuido sends its Sessions from the
// screen's default go-live date.
export interface PatientDraft {
  mode: 'new' | 'existing';
  existingId: number | null;
  firstName: string;
  lastName: string;
  dni: string;
  address: string;
  latitude: string | null;
  longitude: string | null;
  goLiveOn: string;
}

export interface PatientErrors {
  existing?: string;
  firstName?: string;
  lastName?: string;
  dni?: string;
  address?: string;
}

// As the patient and caregiver forms check it.
export function dniError(dni: string): string | undefined {
  if (!dni.trim()) return 'Indica el RUT.';

  return rutHelpers.rutValidate(dni.trim()) ? undefined : 'El RUT ingresado no es válido';
}

function addressError(draft: PatientDraft): string | undefined {
  if (!draft.address.trim()) return 'Indica la dirección principal.';

  return draft.latitude && draft.longitude ? undefined :
    'Elige la dirección de la lista para ubicarla en el mapa.';
}

function newPatientErrors(draft: PatientDraft): PatientErrors {
  return {
    firstName: draft.firstName.trim() ? undefined : 'Indica el nombre.',
    lastName: draft.lastName.trim() ? undefined : 'Indica los apellidos.',
    dni: dniError(draft.dni),
    address: addressError(draft),
  };
}

// What each field is missing.
export function patientErrors(draft: PatientDraft): PatientErrors {
  return draft.mode === 'existing' ?
    { existing: draft.existingId ? undefined : 'Elige el paciente.' } :
    newPatientErrors(draft);
}

export function hasErrors(errors: object): boolean {
  return Object.values(errors).some(Boolean);
}
